<template>
    <div>
        <div class="container" ref="form">

            <div slot="additional-actions" class="pull-right additional-actions">
                <add-new-product></add-new-product>
            </div>

            <div class="uploadProduct">
                <div class="container allinline">
                    <upload-product-csv type="product" class="cstm"
                                        :category-level="this.categoryLevel"
                                        :category="this.category"></upload-product-csv>
                </div>
            </div>
            <product-filter @clicked-show-category="clickedShowCategory"
                            @clicked-show-category-level="clickedShowCategoryLevel"
                            :main-categories="mainCategories"></product-filter>
        </div>
    </div>
</template>

<script>

    import productFilter from './productFilter'
    import ProductCsvUpload from './ProductCsvUpload'
    import addNewProduct from './addNewProduct'

    export default {
        props: ['mainCategories'],
        components: {
            'upload-product-csv': ProductCsvUpload,
            'product-filter': productFilter,
            'add-new-product': addNewProduct,
        },

        data: function () {
            return {
                category: null,
                categoryLevel: '',
            }
        },

        methods: {
            clickedShowCategory(value) {
                this.category = value;
            },
            clickedShowCategoryLevel(value) {
                this.categoryLevel = value;
            },

        },
        mounted: function () {
        },
        watch: {},
        computed: {
            url: function () {
                return process.env.MIX_API_URL;
            },

        }
    }

</script>
